import React, { useEffect } from 'react'
import Accordion from 'react-bootstrap/Accordion';
import { format } from 'date-fns';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { DDMMMYYYYformateDate } from '../../../HelperFunctions';

export const PricingRemarkModal = ({ id, remarkData, handleClose, show }) => {
    // console.log(viewData,"viewData/././")
    // console.log(viewData,"viewData....")
    // useEffect(() => {
    //     const offcanvasElement = document.getElementById(id);
    //     const offcanvasInstance = new Offcanvas(offcanvasElement, {
    //         backdrop: 'static', // prevents closing on outside click
    //         keyboard: false, // disables closing with ESC key
    //     });

    //     return () => {
    //         offcanvasInstance.dispose(); // Clean up when the component unmounts
    //     };
    // }, [id]);
    function formatDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so we add 1
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };
    function formatTime(dateString) {
        if (!dateString) return 'Invalid date'; // handle cases where dateString is undefined or null

        const date = new Date(dateString);

        // Extract time components
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        // const seconds = String(date.getSeconds()).padStart(2, "0");

        // Return only the formatted time string
        return `${hours}:${minutes}`;
    }
    return (
        <Offcanvas show={show} onHide={handleClose} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>View Remark</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                {
                    remarkData?.length > 0 ?
                        <>
                            {remarkData?.map((value, index) => (
                                <Accordion defaultActiveKey={`${index}`} key={index} className='mb-3'>
                                    <Accordion.Item eventKey={index.toString()} >
                                        <Accordion.Header className='remark-accordion'>
                                            {/* {new Date(value?.created_at).toISOString().split('T')[0]}{" "} */}
                                            <div className="remark-header-content w-100 d-flex justify-content-between">
                                                <span className="remark-user remark-font-14">
                                                    {value?.remark_user ? `${value?.remark_user?.name} (${value?.remark_user?.role})` : "-"}
                                                </span>
                                                <div className='d-flex justify-content-start align-items-center gap-3'>
                                                    <span className="remark-date remark-font-14">{DDMMMYYYYformateDate(value?.createdAt)}</span>
                                                    <span className="remark-date remark-font-14">{formatTime(value?.createdAt)}</span>
                                                </div>
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body className="remark-accordion-body-show-query">
                                            {value?.remarks}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            ))}
                        </>
                        :
                        <p>No remarks available</p>
                }
            </Offcanvas.Body>
        </Offcanvas >
    )
}
